import { put, takeLatest } from "redux-saga/effects";

import { loginUserError, loginUserSuccess } from "./actions";
import { LOGIN_USER } from "./constants";

// utils
import requestWrapper from "utils/requestWrapper";
import _local from "utils/localStorageUtils";

export function* loginUserSaga(action) {
  try {
    const { loginValues, isApp } = action;

    let body = {
      email: loginValues.username,
      password: loginValues.password,
      isApp: isApp,
    };

    let response = null;
    // we try to log the user with the data from the form
    if (!!loginValues) {
      response = yield requestWrapper("POST", `auth/login`, body, "");
    }

    const currentUser = response?.user;
    if (!response || (response?.errors && !response?.user)) {
      if (response?.errors && !response?.user) {
        yield put(loginUserError(response?.errors));
      } else {
        yield put(
          loginUserError({
            message: `Login data is Empty.`,
          }),
        );
      }
    } else {
      if (currentUser?._id) {
        const newLocal = _local.setInitLocalUserAndSchool(currentUser);
        let changedUser = {
          ...currentUser,
          schools: newLocal?.schools,
          activeSchool: newLocal?.activeSchool,
        };

        yield put(loginUserSuccess(changedUser, true));
      } else {
        //console.warn('token expire', currentUser);
        yield put(loginUserSuccess(currentUser, false));
      }
    }
  } catch (err) {
    yield put(loginUserError(err));
  }
}

// Individual exports for testing
export default function* loginSaga() {
  yield takeLatest(LOGIN_USER, loginUserSaga);
}
